import React from 'react';
import { Helmet } from 'react-helmet';

const ProductMeta = ({ product }) => {
  if (!product) return null;

  // Sepet sayfasına URL oluştur
  const productURL = `${window.location.origin}/products/${product.id}`;
  
  // Stok durumunu daima "stokta var" kabul edelim
  // Gerçek stok durumu ürün detay sayfasında model ve renk seçimine göre dinamik olarak belirleniyor
  const isInStock = true;

  const title = `${product.name} - Telefon Kılıfı | Mr. Brown Case`;
  const description = product.description || 
    `${product.name} - Özel tasarım telefon kılıfı. Yüksek kaliteli malzemeden üretilmiş, darbelere karşı koruma sağlar.`;
  const imageUrl = product.images;
  
  // Generate keywords from product data
  let keywords = `${product.name}, telefon kılıfı, telefon kapağı, Mr. Brown Case`;
  
  // Add collection to keywords if available
  if (product.collections && product.collections.name) {
    keywords += `, ${product.collections.name}, ${product.collections.name} koleksiyonu`;
  }
  
  // Add phone models to keywords if available
  if (product.phone_models && product.phone_models.length > 0) {
    const modelKeywords = product.phone_models
      .slice(0, 5)
      .map(model => model.brand ? `${model.brand} ${model.model_name || model.name} kılıf` : `${model.name} kılıf`)
      .join(', ');
    
    keywords += `, ${modelKeywords}`;
  }

  return (
    <Helmet>
      {/* Temel Meta Etiketleri */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={productURL} />
      
      {/* Open Graph Etiketleri */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={productURL} />
      <meta property="og:type" content="product" />
      <meta property="og:site_name" content="Mr. Brown Case" />
      <meta property="og:price:amount" content={product.price} />
      <meta property="og:price:currency" content="TRY" />
      <meta property="og:availability" content={isInStock ? "instock" : "outofstock"} />
      <meta property="product:brand" content="Mr. Brown Case" />
      <meta property="product:price:amount" content={product.price} />
      <meta property="product:price:currency" content="TRY" />
      <meta property="product:availability" content={isInStock ? "instock" : "outofstock"} />
      <meta property="product:retailer_item_id" content={`MBC-${product.id}`} />
      
      {/* Twitter Card Etiketleri */}
      <meta name="twitter:card" content="product" />
      <meta property="twitter:domain" content="mrbrowncase.com" />
      <meta property="twitter:url" content={productURL} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:site" content="@mrbrowncase" />
      <meta name="twitter:creator" content="@mrbrowncase" />
      <meta name="twitter:label1" content="Fiyat" />
      <meta name="twitter:data1" content={`${product.price} TL`} />
      <meta name="twitter:label2" content="Kategori" />
      <meta name="twitter:data2" content={product.collections ? product.collections.name : "Telefon Kılıfı"} />
      
      {/* Mobil Uyumluluk */}
      <meta name="format-detection" content="telephone=no" />
      <meta name="theme-color" content="#000000" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black" />
      
      {/* Ek Meta Etiketleri */}
      <meta name="robots" content="index, follow" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Mr. Brown Case" />
    </Helmet>
  );
};

export default ProductMeta; 